import './LanguageSupport.scss';

import { PureComponent } from 'react';
import { Translation } from 'react-i18next';
import AnimateHeight from 'react-animate-height';

import * as Core from 'components/core';
import ColorBar from 'components/ColorBar';

const TRANSITION_DURATION = 300;
const MIN_FILTER_TERM_LENGTH = 2;

interface Props {
  languages: string[];
}

interface State {
  expanded: boolean;
  filterTerm: string;
}

export class LanguageSupport extends PureComponent<Props, State> {
  state: State = {
    expanded: false,
    filterTerm: '',
  };

  toggle = () => {
    this.setState((state) => {
      return {
        ...state,
        expanded: !state.expanded,
        filterTerm: '',
      };
    });
  };

  render() {
    const { languages } = this.props;
    const { expanded, filterTerm } = this.state;

    const normalizedFilterTerm = filterTerm.toLowerCase();
    let filteredLanguages: Array<string> = languages;

    if (filterTerm.length >= MIN_FILTER_TERM_LENGTH) {
      filteredLanguages = languages.filter((language) =>
        language.toLowerCase().includes(normalizedFilterTerm),
      );
    }

    return (
      <Translation>
        {(t) => (
          <>
            <ColorBar>
              <div className="LanguageSupport content-wrapper">
                <h2>{t('family.languageSupport')}</h2>

                <p>{t('family.languageSupportDescription')}</p>

                {languages.length > 0 && (
                  <Core.Button secondary onClick={this.toggle}>
                    {expanded
                      ? t('family.languageSupportHide')
                      : t('family.languageSupportShow')}
                  </Core.Button>
                )}
              </div>
            </ColorBar>

            {languages.length > 0 && (
              <AnimateHeight
                height={expanded ? 'auto' : 0}
                duration={TRANSITION_DURATION}
                className="LanguageSupport-expanded"
              >
                <div className="content-wrapper">
                  <Core.Input
                    type="search"
                    placeholder={
                      t('family.languageSupportInputPlaceholder') as string
                    }
                    value={filterTerm}
                    fullWidth={false}
                    onChange={(event) => {
                      this.setState({
                        filterTerm: event.currentTarget.value,
                      });
                    }}
                  />
                  <div className="LanguageSupport-expanded-list">
                    {filteredLanguages.length > 0
                      ? filteredLanguages.join(', ')
                      : t('family.languageSupportNoResults')}
                  </div>
                </div>
              </AnimateHeight>
            )}
          </>
        )}
      </Translation>
    );
  }
}

export default LanguageSupport;
